import { Client, ModeEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class ModeEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.MODE, (event: ModeEvent) => {
            const { nick, ident, hostname, target, modes, time, account, tags, batch } = event;

            if (target && target.startsWith('#')) {
                const modeStr = modes.map((mode: any) => mode.mode + (mode.param ? ` ${mode.param}` : '')).join(' ');
                const channelTab = this.tM.getTab(tabType.CHANNEL, target);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${nick} sets mode ${modeStr} on ${target}`, IRCMessageType.SYSTEM);
                }

                const hasUserModes = modes.some((mode: any) => {
                    const modeChar = mode.mode.charAt(1);
                    return ['o', 'v', 'h', 'a', 'q'].includes(modeChar) && mode.param;
                });

                if (hasUserModes) {
                    this.cH.refreshUserList(target);
                }
            } else if (target) {
                const modeStr = modes.map((mode: any) => mode.mode + (mode.param ? ` ${mode.param}` : '')).join(' ');
                this.mH.addMessage(this.tM.getStatusTab(), `* ${nick} sets mode ${modeStr} on ${target}`, IRCMessageType.SYSTEM);
            }
        });
    }
}